import { NgModule } from '@angular/core';

import { IframeComponent } from './iframe.component';
import { WavesComponent } from './waves.component';


@NgModule({

  declarations: [
    IframeComponent,
    WavesComponent
  ],
  exports: [
    IframeComponent,
    WavesComponent
  ]
})
export class SharedModule { }


// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts